import React from 'react'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import Style from './Slider.module.css'
import { separate } from '../../Functions/NumberSeprator';
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none", background: "red" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none", background: "green" }}
      onClick={onClick}
    />
  );
}

const SliderFood = ({list}) => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1.5,
        slidesToScroll: 1,
        rtl: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
      };
      return (
        <div className={Style.SliderHolder}>
          <Slider {...settings} className={Style.SliderPart}>
          {
                list.map((item,index)=>{
                  return(
                  <div key={index} className={Style.EachSlide}>
                    <h3 style={{fontSize: ".9rem"}}>{item.category_persian}</h3>
                    <p className={Style.IncomeHolder}>درآمدکلی:<span>{separate(item.income)}تومان</span></p>
                    <p className={Style.saleCountHolder}>تعداد فروش:<span>{item.count}</span></p>
                  </div>
                  )
                })
              }
           
          </Slider>
        </div>
      );
}

export default SliderFood
